// eslint-disable-next-line no-unused-vars
import React, { memo, useCallback } from 'react';
import { useContextSelector } from 'use-context-selector';

// eslint-disable-next-line import/no-named-as-default-member
import AccountSideMenuComponent from 'Components/AccountSideMenu/AccountSideMenu';
import { WishlistContext } from 'Contexts/WishlistContext';
import useRouter from 'Hooks/useRouter';

const AccountSideMenu = memo(() => {
  const { params } = useRouter();
  const { pathname } = useRouter();
  const lists = useContextSelector(WishlistContext, data => data?.data || []);
  const stockAlertList = useContextSelector(WishlistContext, data => data?.stockAlertWishlist);

  const findOpen = useCallback(() => {
    if (pathname.includes('profile') || pathname.includes('settings') || pathname.includes('personal-data')) {
      return 'account';
    }
    if (pathname.includes('orders')) {
      return 'orders';
    }
    if (pathname.includes('offers')) {
      return 'offers';
    }
    if (pathname.includes('invoices') || pathname.includes('payments') || pathname.includes('reservations') || pathname.includes('balance') || pathname.includes('account-statements')) {
      return 'reports';
    }
    if (pathname.includes('feeds') || pathname.includes('api-information') || pathname.includes('ecommerce-tools')) {
      return 'api-integrations';
    }
    if (pathname.includes('info')) {
      return 'info';
    }
    if (pathname.includes('lists/')) {
      return 'lists';
    }
    return 'dashboard';
  }, [pathname]);

  const findActive = useCallback(() => pathname, [pathname]);

  return (
    <AccountSideMenuComponent
      lists={ [stockAlertList].concat(Object.values(lists || {})) }
      selectedListId={ params.id }
      defaultOpen={ findOpen(pathname) }
      defaultActive={ findActive(pathname) }
    />
  );
});

AccountSideMenu.displayName = 'AccountSideMenuContainer';

export default AccountSideMenu;
